/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import authReducer from "../features/auth/authSlice";
import archiveReducer from "../features/office-archive/archiveSlice";
import adminReducer from "../features/admin/adminSlice";
import userManagementReducer from "../features/admin/user-management/userManagementSlice";
import companiesReducer from "../features/office-companies/companiesSlice";
import sitesReducer from "../features/office-work-sites/workSitesSlice";
import workOrdersReducer from "../features/office-work-orders/workOrdersSlice";
import assetsReducer from "../features/assets-manager/assetsSlice";
import localConfigReducer from "../features/auth/localConfigSlice";
import techwiseOfficesReducer from "../features/materials-techwise-offices/techwiseOfficesSlice";
import notificationsReducer from "../features/nav/notificationsSlice";
import dataTablesReducer from "../components/table/dataTablesSlice";

export const store = configureStore({
    reducer: {
        localConfig: localConfigReducer,
        auth: authReducer,
        archive: archiveReducer,
        admin: adminReducer,
        userManagement: userManagementReducer,
        companies: companiesReducer,
        sites: sitesReducer,
        workOrders: workOrdersReducer,
        assets: assetsReducer,
        locations: techwiseOfficesReducer,
        notifications: notificationsReducer,
        dataTables: dataTablesReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
